module.exports = __webpack_public_path__ + "img/news_banner.6a79d157.png";